/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_Already_ScannedInputs */

const en_verify_already_scanned = /** @type {(inputs: Verify_Already_ScannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already Scanned`)
};

const es_verify_already_scanned = /** @type {(inputs: Verify_Already_ScannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya Escaneado`)
};

const fr_verify_already_scanned = /** @type {(inputs: Verify_Already_ScannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déjà scanné`)
};

const de_verify_already_scanned = /** @type {(inputs: Verify_Already_ScannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereits gescannt`)
};

const id_verify_already_scanned = /** @type {(inputs: Verify_Already_ScannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sudah Dipindai`)
};

/** @type {(inputs: Verify_Already_ScannedInputs) => LocalizedString} */
const ja_verify_already_scanned = en_verify_already_scanned;

/** @type {(inputs: Verify_Already_ScannedInputs) => LocalizedString} */
const zh_verify_already_scanned = en_verify_already_scanned;

/** @type {(inputs: Verify_Already_ScannedInputs) => LocalizedString} */
const ar_verify_already_scanned = en_verify_already_scanned;

/** @type {(inputs: Verify_Already_ScannedInputs) => LocalizedString} */
const it_verify_already_scanned = en_verify_already_scanned;

/** @type {(inputs: Verify_Already_ScannedInputs) => LocalizedString} */
const ru_verify_already_scanned = en_verify_already_scanned;

/** @type {(inputs: Verify_Already_ScannedInputs) => LocalizedString} */
const pt_verify_already_scanned = en_verify_already_scanned;

/** @type {(inputs: Verify_Already_ScannedInputs) => LocalizedString} */
const ko_verify_already_scanned = en_verify_already_scanned;

/**
* | output |
* | --- |
* | "Already Scanned" |
*
* @param {Verify_Already_ScannedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const verify_already_scanned = /** @type {((inputs?: Verify_Already_ScannedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_Already_ScannedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verify_already_scanned(inputs)
	if (locale === "es") return es_verify_already_scanned(inputs)
	if (locale === "fr") return fr_verify_already_scanned(inputs)
	if (locale === "de") return de_verify_already_scanned(inputs)
	if (locale === "ja") return ja_verify_already_scanned(inputs)
	if (locale === "zh") return zh_verify_already_scanned(inputs)
	if (locale === "ar") return ar_verify_already_scanned(inputs)
	if (locale === "id") return id_verify_already_scanned(inputs)
	if (locale === "it") return it_verify_already_scanned(inputs)
	if (locale === "ru") return ru_verify_already_scanned(inputs)
	if (locale === "pt") return pt_verify_already_scanned(inputs)
	return ko_verify_already_scanned(inputs)
});